import { useMemo } from "react";
import { useNavigate } from "react-router";
import {
    MIcons,
    MTooltip,
    MTypography,
} from "@material-dev/insights-portal-ui-components/lib";

export interface RecentlyViewedItemProps {
    itemId: number;
    itemType: "Project" | "Dataset"
    name: string,
    description: string;
    isStarred?: boolean;
}
export const RecentlyViewedItem = ({ description, name, itemId, itemType, isStarred }: RecentlyViewedItemProps) => {

    const link = useMemo(() => {
        if (itemType === "Dataset") {
            return `/datasets/${itemId}`
        }
        else {
            console.log(itemId)
            return `/project/${itemId}`
        }
    }, [itemId, itemType])

    const navigate = useNavigate();

    const handleOnClick = () => {
        navigate(link);
    }

    return ( 
        <div className="list-item" onClick={handleOnClick}>
        <div className="cell id-column">{name}</div>
        <div className="cell">
            <MTooltip title={description} arrow >
                <MTypography className="description-cell">
                    {description}
                </MTypography>
            </MTooltip>
        </div>
        {itemType == "Project" && <div className="cell star-column">
            {isStarred && <MIcons.FilledStar />}
        </div>}
         
    </div>)
}
